
const digest = 'e741db7426da25ba5cc01542ea5a9b9503683c79ae86fc5f3af0d20c1f1947b4';
const css = `._commandMenuItem_14z45_1 {
  display: contents; /* Let the natural display of children (implicit in aha-menu-item) take over. */
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItem":"_commandMenuItem_14z45_1"};
export { css, digest };
  